import React, { useState, useEffect } from "react";
//Styles
import "../../../assets/css/form.css";
//Cookie token
import cookie from "react-cookies";
//Router
import { useHistory, useParams } from "react-router-dom";
//GraphQL
import { useLazyQuery, gql } from "@apollo/client";
//Redux
import { useDispatch, useSelector } from "react-redux";
import {
  loadFormSettings,
  loadFormValue,
} from "../../../actions/formDataActions";
//Components
import Form from "../../formSections/Form";

const BusinessGroupsUpdate = () => {
  //Redirect if not logged in
  let history = useHistory();
  const token = cookie.load("usertk");
  let { id } = useParams();

  //Store data
  const { settings } = useSelector((state) => state.dataForm);

  //States
  const [displayForm, setDisplayForm] = useState(false);

  //API
  const GET_BUSINESSGROUP_2UPDATE = gql`
    query getBusinessGroup {
        getBusinessGroup(id: ${id}) {
            id
            name
        }
    }
  `;

  const [getBusinessGroup, { error, data }] = useLazyQuery(
    GET_BUSINESSGROUP_2UPDATE
  );

  //Redux actions
  const dispatch = useDispatch();
  const storeLoadFormValue = (valuePair) => dispatch(loadFormValue(valuePair));
  const storeLoadSettings = (defaultSettings) =>
    dispatch(loadFormSettings(defaultSettings));

  //useEffect
  useEffect(() => {
    if (settings && settings !== {}) {
      setDisplayForm(true);
    } else {
      setDisplayForm(false);
    }
    // eslint-disable-next-line
  }, [settings]);

  useEffect(() => {
    if (data && !error) {
      //Section Settings
      const defaultSettings = {
        entity: "businessGroup",
        queryName: "updateBusinessGroup",
        title: "Editar Grupo de Empresas",
        text: "Por favor, modifique el nombre del Grupo de empresas y después pulse en aceptar para que los cambios se guarden.",
        formContent: [
          {
            type: "fieldText",
            name: "name",
            size: 75,
            label: "Nombre del grupo de empresas",
            placeholder: "Nombre del Grupo de Empresas",
            required: true,
            validated: true,
            validation: "notEmpty",
            defaultValue: data.getBusinessGroup.name,
          },
          {
            type: "buttons",
            buttons: [
              {
                text: "Actualizar",
                action: "update",
                classes: "safe",
                actionType: "update",
                entity: "businessGroup",
                id: id,
              },
              {
                text: "Cancelar",
                action: "link",
                link: "/buscar-grupo-de-empresas",
                classes: "unsafe",
                entity: "businessGroup",
              },
            ],
          },
        ],
      };
      storeLoadSettings(defaultSettings);
    }

    // eslint-disable-next-line
  }, [data, error]);

  useEffect(() => {
    getBusinessGroup();
    //Load id value to store
    storeLoadFormValue(["id", id]);
    // eslint-disable-next-line
  }, []);

  return (
    <>
      {!token ? (
        history.push("/")
      ) : (
        <>
          <div className="table-container">{displayForm && <Form />}</div>
        </>
      )}
    </>
  );
};

export default BusinessGroupsUpdate;
